import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/19.mp3"
export default function P1() {
    return (
        <MainLayout
        title="Kto to Samotny Olęder?"     
        question="" 
            audio={audio}
        answers={{
            ans1: "Dalej",
        }}
        links={{
            link1: PAGES.p34,
        }}
        content={
            <div>
                <ul>
                    <li>Kim jest Samotny Olęder?</li>
                    <li>Damy ci trochę smoły, to Samotnemu Olędrowi zaniesiesz!</li>
                    <li>Posmarować płetwę smołą, potem wsadzić w piasek albo plewy i gotowe… Zresztą staruszek Olęder pewnie niejeden piracki okręt już smołował. Może wpuści cię na pokład na następny rejs!</li>
                </ul>
                <p>
                Dzięki tobie gęsiarze mają z kogo pożartować. Nic tu po tobie, najlepiej bawią się w swoim własnym towarzystwie. Kierujesz się do sadu Emila, w końcu po południu mieliście wrócić razem do Tarszewa.
                </p>
            </div>
        }
        />
        
            );
}